<template>
  <div v-if="videocate !== null">
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="videocate.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="videocate.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>群組</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="videocate.support_categories_id"
            :items="supportcates"
            placeholder="請選擇所屬群組"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="videocate.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="videocate.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="videocate.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    FormSwitch,
  },
  data: () => ({
    tab: '',
    status: true,
    bu: [],
    supportcates: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState(['buTabs']),
    ...mapState('videocate', ['videocate']),
  },
  async created() {
    if (this.videocate.support_categories_id !== null) {
      this.supportcates = await this.getSupportVIDEOCates(this.videocate.support_categories_id);
    }
  },
  watch: {
    async 'videocate.support_categories_id'(newValue) {
      if (newValue !== '') {
        this.supportcates = await this.getSupportVIDEOCates(newValue);
      } else {
        this.supportcates = [];
      }
    },
  },
  methods: {
    ...mapActions('videocate', ['getSupportVIDEOCates']),
  },
};
</script>

<style></style>
